var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ik-data-table',{class:_vm.$vuetify.breakpoint.mobile ? 'mt-4' : 'mt-2',attrs:{"entity-name":"pay","model":_vm.model,"icon":"mdi-cash-plus"}})
}
var staticRenderFns = []

export { render, staticRenderFns }